module.exports = __webpack_public_path__ + "static/media/IconTemplates_-12.9f6d2b70.svg";